import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { HttpService } from '../services/http.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: HttpService, public toast: ToastrService, public route:Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     // 1. GET THE TOKEN FROM STORAGE
    const token = localStorage.getItem('TOKEN');

    // 2. ATTACH TOKEN TO EVERY OUTGOING REQUEST
    if (token) {
      request = this.addToken(request, token);
    }

    return next.handle(request).pipe(
      catchError(error => {        
        console.log("inside interceptor")
        if (error.status === 401 && !request.url.includes('/professional/refresh/')) {
          return this.handle401Error(request, next);
        }
        return throwError(() => error);
        
      })
    );
  }

  /**
   * Add access token to request headers
   */
  private addToken(request: HttpRequest<any>, token: string | null) {

    if (!token) {
      return request;
    }

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  /**
   * Handle 401 Unauthorized errors
   */
  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log("inside handle 401")
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((response: any) => {
          console.log("refresh response ", response)
          this.isRefreshing = false;
          const newToken = response.data.access_token
          this.authService.setAuthToken(newToken); 
          this.refreshTokenSubject.next(newToken);
          return next.handle(this.addToken(request, newToken));
          
        }),
        catchError((err) => {
          console.log("refresh error", err)
          this.isRefreshing = false;
          
          if (err.status == 401 && err.url.includes('/refresh/')){
            this.toast.error("session expired, please login again")
            this.authService.finishLogout()
            
          }
          
          return throwError(() => err);
        })
      );
    } else {
      // Wait for token refresh to complete, then retry the request
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.addToken(request, token));
        })
      );
    }
  }
}